export const genericConstants = {
  RESET: 'RESET',
  REQUEST_IN_PROGRESS: 'REQUESTING',
  REQUEST_SUCCESS: 'REQUEST_SUCCESS',
  REQUEST_FAILURE: 'REQUEST_FAILURE'
};



// WEBPACK FOOTER //
// ./src/_constants/generic.constants.js